import { Box, Link, makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { getHistory, useRouter } from "@shoothill/core";
import { StoresInstance } from "Globals/Stores";
import { CustomInput } from "Globals/Styles/AppStyling";
import { StyledButton } from "Globals/Styles/ButtonStyles";
import { EditableCopyViewModel } from "Globals/ViewModels/EditableCopyViewModel";
import { useObserver } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";
import { LoginViewModel } from "./LoginViewModel";

const domainStores = StoresInstance.Domain;

const BackgroundImageContainer = styled(Box)`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    min-height: 100vh;
    height: auto;
    background-image: url("login_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;
const Row = styled(Box)`
    display: flex;
    margin: 30px 0;
    @media (max-width: 768px) {
        justify-content: center;
        margin: 15px 0;
    }
`;

const useStyles = makeStyles({
    wrapper: {
        padding: "90px 120px 0 80px",
        backgroundColor: "#ffffffef",

        "@media (max-width:768px)": {
            padding: "50px 10px 10px",
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
        },
    },
    p1: {
        fontSize: "18px",
        "@media (max-width:768px)": {
            textAlign: "center",
        },
    },
    form: {
        "@media (max-width: 768px)": {
            width: "100%",
            marginTop: "80px",
        },
    },
    input: {
        "& .MuiInputBase-input": {
            "@media (max-width: 768px)": {
                height: "48px",
                boxSizing: "border-box",
                width: "300px",
            },
        },
        "& .MuiFormControl-root": {
            "@media (max-width: 768px)": {
                boxSizing: "border-box",
                width: "300px",
                margin: "15px 0",
            },
        },
    },
});

export const LoginView: React.FunctionComponent = () => {
    const [viewModel] = useState(() => new LoginViewModel());
    const [viewEditableCopyModel] = useState(() => new EditableCopyViewModel());
    const { history, location, match } = useRouter();
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState("");
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    const classes = useStyles();
    useEffect(() => {
        if (StoresInstance.Domain.AccountStore.IsLoggedIn) {
            history.push("/");
        }
    }, []);

    const doSubmit = async (e: any) => {
        e.preventDefault();
        if (await viewModel.isModelValid()) {
            const apiResult = await viewModel.login();
            if (apiResult !== null) {
                if (apiResult.wasSuccessful) {
                    await domainStores.AccountStore.getLoginState(apiResult.payload as any);
                    const { from } = (location.state as any) || { from: { pathname: "/" } };
                    if (from) {
                        history.push(from.pathname);
                    }
                } else {
                    if (apiResult && apiResult.errors && apiResult.errors.length > 0) {
                        setErrorMessage("* " + apiResult.errors[0].message);
                    } else {
                        setErrorMessage("* Unknown error has occurred.");
                    }
                }
            }
        }
    };

    return useObserver(() => (
        <>
            <BackgroundImageContainer>
                <Box className={classes.wrapper}>
                    <Row>
                        <img
                            src="/hightownLogo.svg"
                            alt="Hightown"
                            style={isMobile ? { width: "250px" } : { cursor: "pointer", width: "363px" }}
                            onClick={() => getHistory().push("/")}
                        />
                    </Row>
                    <Row>
                        <Typography style={{ fontSize: "28px", fontWeight: "bold" }}>Login</Typography>
                    </Row>
                    <Row>
                        <Typography className={classes.p1}>Welcome to the Hightown Housing Group customer application portal.</Typography>
                    </Row>
                    <form onSubmit={doSubmit} className={classes.form}>
                        <Row>
                            {errorMessage !== "" && (
                                <Typography variant="caption" style={{ color: "red" }}>
                                    {errorMessage}
                                </Typography>
                            )}
                        </Row>
                        <Row>
                            <CustomInput className={classes.input} type="email" label="Email Address" validateOnBlur={true} viewModel={viewModel} fieldName="emailAddress" />
                        </Row>
                        <Row>
                            <Box>
                                <CustomInput className={classes.input} type="password" label="Password" viewModel={viewModel} fieldName="password" />
                                <Link component={RouterLink} to="forgotpassword" style={{ display: "block", marginTop: "25px" }}>
                                    <Typography style={{ color: "#007AFF", cursor: "pointer", textDecoration: "underline", fontSize: "12px" }}>
                                        I've forgotten my password
                                    </Typography>
                                </Link>
                            </Box>
                        </Row>
                        <Row>
                            <StyledButton style={{ margin: 0 }} type="submit">
                                {viewModel.IsLoading ? <span>Please wait...</span> : <span>Login</span>}
                            </StyledButton>
                        </Row>
                    </form>
                </Box>
            </BackgroundImageContainer>
        </>
    ));
};
